<template>
	<v-layout row v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<agency-choose-project-type
				:contest-id="contestId"
				v-model="old"
				:readonly="true"
			></agency-choose-project-type>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<agency-choose-project-type
				:contest-id="contestId"
				v-model="current"
				:readonly="true"
			></agency-choose-project-type>
		</v-flex>
	</v-layout>
</template>
<script>
	import NewVersionMarker from "../../offer/compareComponents/NewVersionMarker";
	import OldVersionMarker from "../../offer/compareComponents/oldVersionMarker";
	import AgencyChooseProjectType from "../components/AgencyChooseProjectType";

	export default {
		name: 'CompareProjectTypes',
		components: {AgencyChooseProjectType, NewVersionMarker, OldVersionMarker},

		computed: {
			dataSame() {
				let comparisonResult = this.current === this.old;
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			current: {},
			old: {},
			contestId: {}
		}
	};
</script>
